import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Card } from 'react-toolbox/lib/card';
import DataTable from '../../../../common/components/DataTable';
import {Button} from '../../../../common/components';
import HorizontalRule from '../HorizontalRule';
import {
  TitleBar,
  DocTitle,
} from '../../../../common/components/Layout/StandardPageTemplate/Context';
import { withLoading } from '../../../../redux-modules/loading-overlay';
import TransactionActions from '../../actions/transactions';
import { getTransactions } from '../../selectors/transactions';
import ActionHandler from '../ActionHandler';
import styles from './TransactionsPage.css';
import { getCurrentUser } from '../../../../redux-modules/current-user';
import { getCustomer } from '../../../../redux-modules/customers';
import { getOrganization } from '../../../../redux-modules/organizations';
import Dialog from 'react-toolbox/lib/dialog';
import RequestActions from '../../../account/actions/customers/requests';

const NoData = ({ colSpan, message }) => {
  return (
    <tbody>
      <tr>
        <td colSpan={colSpan}>
          <h3
            style={{
              width: '100%',
              textAlign: 'center',
              padding: '15px 0',
              color: '#757575',
            }}
          >
            {message}
          </h3>
        </td>
      </tr>
    </tbody>
  );
};
NoData.propTypes = {
  colSpan: PropTypes.number,
  message: PropTypes.string,
};

const formatDate = value => {
  const date = moment(value);
  return date.format('MM-DD-YYYY');
};

const formatCurrency = value => {
  return `$${value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
};

const alignChildren = (children, alignment) => {
  return <p style={{ textAlign: alignment }}>{children}</p>;
};

class TransactionsPage extends React.Component {
  static propTypes = {
    transactions: PropTypes.arrayOf(PropTypes.object),
    currentUser: PropTypes.shape({
      id: PropTypes.string,
    }),
    currentCustomer: PropTypes.object,
    organizations: PropTypes.object,
    isLoading: PropTypes.bool,
    actions: PropTypes.shape({
      transactions: PropTypes.objectOf(PropTypes.func),
      requests: PropTypes.objectOf(PropTypes.func),
    }),
  };
  state = {
    isModalActive: false,
    isComplianceModalActive: false,
    hasExistingAutoDuesRequest: false,
    hasCheckedAutoDuesRequest: false,
  };

  fetchAutoDuesTerminationRequest = () => {
    const { currentUser, organizations, actions } = this.props;
    if (!currentUser || !currentUser.id || !organizations || !organizations.membershipDetails || !organizations.membershipDetails.isAutoPay) return;
    actions.requests
      .get(null, { params: { summary: 'Auto Dues Termination Request' } })
      .then((results) => {
        const { payload: { json } = {} } = results || {};
        const hasData = (json && json.items && json.items.length > 0) || (Array.isArray(json) && json.length > 0);
        this.setState({
          hasCheckedAutoDuesRequest: true,
          hasExistingAutoDuesRequest: !!hasData,
        });
      })
      .catch(() => {
        this.setState({ hasCheckedAutoDuesRequest: true });
      });
  };

  componentDidMount() {
    this.fetchAutoDuesTerminationRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.organizations !== prevProps.organizations &&
      this.props.organizations && this.props.organizations.membershipDetails && this.props.organizations.membershipDetails.isAutoPay
    ) {
      this.fetchAutoDuesTerminationRequest();
    }
  }
  static page = {
    color: 'green',
    title: 'My Transactions',
  };
  static promises = {
    includePromises: [
      {
        type: 'ENTITY/ENTITY_GET',
        meta: { namespace: 'transactions' },
      },
    ],
  };

  static columnDefinitions = {
    dateTime: { title: 'Date', render: formatDate, sortType: 'date' },
    description: { title: 'Product', sortType: 'string' },
    paymentDescription: { title: 'Method', sortType: 'string' },
    total: {
      title: '$',
      sortType: 'number',
      titleClassName: styles.totalHeading,
      render: value => alignChildren(formatCurrency(value), 'right'),
    },
  };

  autoDueRequest = ()=>{

    const { currentCustomer, organizations } = this.props;
    const dateNow = new Date();
    const frequency = organizations.membershipDetails.duesPaymentFrequency == 12 ? "annual" : (organizations.membershipDetails.duesPaymentFrequency == 3 ? "quarterly" : "monthly");
    const businessPhone = organizations.phoneNumbers && organizations.phoneNumbers.find(phone => phone.type === 'Business');
    const businessPhoneNumber = businessPhone && businessPhone.number


    const detail = `Date: ${dateNow}
    Member ID: ${organizations.id}
    Organization Name: ${organizations.organizationDetails.name}
    Primary Contact Name: ${currentCustomer.personalDetails.firstName} ${currentCustomer.personalDetails.lastName}
    Primary Contact Email Address: ${currentCustomer.contactDetails.emailAddress}
    Business Phone Number: ${businessPhoneNumber}
    AutoDues Schedule: ${frequency}
    AutoDues Amount: ${organizations.membershipDetails.duesPaymentAmount}`;

    const requestBody =
    {
      detail :  detail,
      emailSubject : `${organizations.id} Auto Dues Termination Request`,
      contactInfo : {
        "isMember": true,
        "firstName": currentCustomer.personalDetails.firstName,
        "lastName": currentCustomer.personalDetails.lastName,
        "firmName": currentCustomer.summaryDetails.organizationUnboundName,
        "emailAddress": currentCustomer.contactDetails.emailAddress,
        "phoneNumber": businessPhoneNumber,
      },
      Summary: 'Auto Dues Termination Request',
      address: organizations.addresses[0]
    }
    
    this.props.actions.requests.post(requestBody).then((results) => {
      const { payload: { resp } = {} } = results || {};
      if (resp && resp.ok) {
        this.setState({ hasExistingAutoDuesRequest: true });
      }
    }).catch(function(ex) {
      alert("Auto Dues Termination Request failed")
    }); 

    this.setState(prevState=>({isModalActive: false}));
  };

  autoDueComplianceRequest = ()=>{

    const { currentCustomer, organizations } = this.props;
    const dateNow = new Date();
    const businessPhone = organizations.phoneNumbers && organizations.phoneNumbers.find(phone => phone.type === 'Business');
    const businessPhoneNumber = businessPhone && businessPhone.number


    const detail = `Date: ${dateNow}
    Individual ID: ${currentCustomer.id}
    Individual Name: ${currentCustomer.personalDetails.firstName} ${currentCustomer.personalDetails.lastName}
    Individual Email Address: ${currentCustomer.contactDetails.emailAddress}
    Business Phone Number: ${businessPhoneNumber}`;

    const requestBody =
    {
      assignee : "NFIBCompliance",
      detail :  detail,
      emailSubject : `${currentCustomer.id} Auto Contribution Termination Request`
    }

   this.props.actions.requests.post(requestBody).then(results=>{
    }).catch(function(ex) {
      alert("Auto Contribution Termination Request")
    });

    this.setState(prevState=>({isComplianceModalActive: false}));
  };

  render() {
    const { transactions, organizations, currentCustomer } = this.props;
    var frequencyText = "";
    if (organizations && organizations.membershipDetails) {
      var frequency = organizations.membershipDetails.duesPaymentFrequency;
      frequencyText = frequency == 12 ? "annual" : (frequency == 3 ? "quarterly" : "monthly");
    }
    const actions = [
      { label: 'cancel', onClick: ()=>{ this.setState(prevState=>({isModalActive: false})); }},
      { label: 'confirm', onClick: this.autoDueRequest },
    ];
    const complianceActions = [
      { label: 'cancel', onClick: ()=>{ this.setState(prevState=>({isComplianceModalActive: false})); }},
      { label: 'confirm', onClick: this.autoDueComplianceRequest },
    ];
    return (
      <div>
        <TitleBar title={TransactionsPage.page.title} />
        <DocTitle title={TransactionsPage.page.title} />
        {organizations && organizations.membershipDetails && organizations.membershipDetails.isAutoPay && this.state.hasCheckedAutoDuesRequest && !this.state.hasExistingAutoDuesRequest && (
          <div style={{ margin: 5, marginBottom:15 }}>
            <Dialog
              actions={actions}
              active={this.state.isModalActive}
              title={''}
              style={{ fontSize: '1.4rem' }}
            >
              <p>Please confirm your request to stop your {frequencyText} installment payments of ${organizations.membershipDetails.duesPaymentAmount} for your annual NFIB membership dues for member {organizations.organizationDetails.name} (ID: {organizations.id}).</p>
              <h4 style={{ marginTop: 10 }}>Please allow 2-3 business days to process your request.</h4>
              <p style={{ marginTop: 10 }}>Thank you.</p>
            </Dialog>
            <span>Click <span style={{ cursor: 'pointer', fontWeight: 'bold', color: '#0c64c0', textDecoration: 'underline' }} onClick={() => { this.setState(prevState => ({ isModalActive: true })); }}>here</span> to stop my {frequencyText} installment payments for my annual NFIB membership dues.</span>
          </div>)}

          {currentCustomer && currentCustomer.isAutoPac && (
          <div style={{ margin: 5 }}>
            <Dialog
              actions={complianceActions}
              active={this.state.isComplianceModalActive}
              title={''}
              style={{ fontSize: '1.4rem' }}
            >
              <p>Please confirm your request to stop your automated NFIB PAC contributions. {currentCustomer.personalDetails.firstName} {currentCustomer.personalDetails.lastName}</p>
              <h4 style={{ marginTop: 10 }}>Please allow 2-3 business days to process your request.</h4>
              <p style={{ marginTop: 10 }}>Thank you.</p>
            </Dialog>
            <span>Click <span style={{ cursor: 'pointer', fontWeight: 'bold', color: '#0c64c0' }} onClick={() => { this.setState(prevState => ({ isComplianceModalActive: true })); }}>here</span> to stop my automated NFIB PAC contributions.</span>
          </div>)}
        <ActionHandler
          condition={!transactions || !transactions.length}
          action={this.props.actions.transactions.get}
        />
        <Card style={{ overflowX: 'auto', boxShadow: 'none' }}>
          <DataTable
            sortKey="dateTime"
            sortDirection="DESC"
            columnDefinitions={TransactionsPage.columnDefinitions}
            data={transactions}
            theme={styles}
          >
            <NoData
              colSpan={Object.keys(TransactionsPage.columnDefinitions).length}
              message={this.props.isLoading ? 'Loading...' : 'No Transactions'}
            />
          </DataTable>
        </Card>
        <HorizontalRule color="green" />
        <Button
          to="/account"
          className={styles.button}
          label="Back to Account Management"
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
    const currentUser = getCurrentUser(state);
    const currentCustomer = getCustomer(state, { id: currentUser.id });
    let currentOrganization;
    if (
      currentCustomer &&
      currentCustomer.organization &&
      currentCustomer.organization.key
    ) {
      currentOrganization = getOrganization(state, {
        id: currentCustomer.organization.key,
      });
    }
    return {
      currentCustomer,
      currentUser,
      transactions: getTransactions(state),
      organizations: currentOrganization
    };
};

const mapDispatchToProps = dispatch => {
  return {dispatch};
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    actions: {
      transactions: bindActionCreators(TransactionActions, dispatchProps.dispatch),
      requests: bindActionCreators(
        RequestActions(stateProps.currentUser.id),
        dispatchProps.dispatch
      )
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
  withLoading(TransactionsPage)
);



// WEBPACK FOOTER //
// ./src/App/account/components/TransactionsPage/index.js